import React, { ReactNode } from "react"
import clsx from "clsx"
import Icon from "ui/components/atoms/icon"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Typography.module.css"

export type LabelProps = BaseStyles & {
  children: ReactNode
  icon?: string
  iconText?: string
  $type?: string
  $color?: string
  $iconSize?: string
  $iconColor?: string
}

export const Label = ({
  children,
  icon,
  iconText,
  $type,
  $color,
  $iconSize,
  $iconColor,
  className = "",
  style = {},
  ...rest
}: LabelProps & { className?: string; style?: React.CSSProperties }) => {
  const generatedStyles = generateStylesFromProps({ ...rest, $color })

  const labelClasses = clsx(
    styles.label,
    {
      [styles.secondary]: $type === "secondary",
      [styles.third]: $type === "third",
      [styles.withIcon]: !!icon,
    },
    className,
  )

  const labelStyles = {
    ...generatedStyles,
    ...style,
  }

  return (
    <label className={labelClasses} style={labelStyles}>
      {icon && <Icon icon={icon} $color={$iconColor ?? $color} $size={$iconSize} />}
      {iconText && (
        <span
          className={styles.labelSpan}
          style={{
            color: $iconColor ? `var(--color-${$iconColor})` : `var(--color-${$color || "second"})`,
          }}
        >
          {iconText}
        </span>
      )}
      {children}
    </label>
  )
}
